module.exports = __webpack_public_path__ + "img/card_11.113968d5.png";